<template>
  <div id="app">
    <div class="top">
      <div class="topBanner dFlex">
        <div class="topL topIn">
          <a @click="show2" target="index" href="https://yooobei.com/#/#/">
            <img src="./assets/logo.png" alt="" />
          </a>
        </div>
        <div v-if="detail.ad_00" class="topR topIn">
          <a target="view_frame0" :href="detail.ad_00[0].linkurl">
            <van-image
              width="58.125rem"
              height="3.875rem"
              :src="detail.ad_00[0].imageurl"
            />
          </a>
        </div>
      </div>
    </div>
    <div id="mid" class="mid">
      <div class="topBanner wxDw">
        <div class="midList">
          <van-tabs
            @disabled="onClickDisabled"
            v-model="active"
            @click="onClick"
            background="#434B58"
            swipe-threshold="9"
            color="#FF5E04"
            title-inactive-color="#fff"
            type="card"
          >
            <van-tab title="首页" to="/"></van-tab>
            <van-tab title="游呗播报" to="/Broadcast"></van-tab>
            <van-tab title="资讯" to="/Information"></van-tab>
            <van-tab title="视频" to="/Video"></van-tab>
            <van-tab title="商城" disabled @click="noNe()"></van-tab>
            <van-tab title="专题" disabled @click="noNe()"></van-tab>
            <van-tab title="美图" to="/Mito"></van-tab>
          </van-tabs>
        </div>
        <ul class="ybIcon" @click="toDetail()">
          <li class="appIcon">
            <img src="./assets/ic_shouji@2x.png" alt="" />游呗APP
          </li>
          <div class="app">
            <div class="ewmText" style="width: 6rem">扫码下载游呗APP</div>
            <van-image
              width="6rem"
              height="6rem"
              :src="require('./assets/app.png')"
            />
          </div>
          <li class="gzhIcon">
            <img src="./assets/ic_weixin@2x.png" alt="" />游呗公众号
          </li>
          <!-- <li><img src="./assets/ic_dianhua@2x(1).png" alt=""></li> -->
          <div class="gzh">
            <div class="ewmText" style="width: 6rem">
              "扫一扫"关注游呗官方微信
            </div>
            <van-image
              width="6rem"
              height="6rem"
              :src="require('./assets/gzh.jpg')"
            />
          </div>
        </ul>
      </div>
    </div>
    <div id="box" class="box">
      <div class="topBanner teshu">
        <router-view @change="tabChange" />
      </div>
    </div>
    <div id="bot" class="bot">
      <div class="topBanner">
        <div class="botBanB dFlex">
          <p>主办单位：北京游呗科技有限公司</p>
          <p>Copyright 2017-2020 游呗yooobei.com版权所有</p>
          <p>Operated by Beijing Youbei Technology Co., Ltd.</p>
          <div class="dFlex" style="align-items: center">
            <van-image
              width="1.25rem"
              height="1.25rem"
              :src="require('./assets/anquan@2x.png')"
            />
            <a href="https://beian.miit.gov.cn">京ICP备17034220号-1</a>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- </div> -->
</template>
<script>
import QRCode from "qrcodejs2";
import wx from "weixin-js-sdk";
import { postHome } from "../src/utils/requerst/requerst";
import { isPc, parseQueryString2 } from "../src/utils/util";
import { jssdkConfig } from "../src/utils/requerst/requerst";
export default {
  data() {
    return {
      // swiper参数
      detail: "",
      active: 0,
    };
  },
  methods: {
    show2() {
      this.$router.replace("/");
      document.querySelector(".top").style.display = "block";
      document.querySelector(".mid").style.display = "block";
      window.location.reload();
    },
    onClick(res) {
      document.title = "游呗旅行网";
      const title = "游呗旅行网";
      const imgUrl = "https://www.uobay.com/images/sharelogo.png";
      const desc = "游呗旅行网——旅游综合服务平台";
      let link = "";
      link = location.href;
      wx.ready(() => {
        wx.updateAppMessageShareData({
          title: title, // 分享标题
          desc: desc, // 分享描述
          link: link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
          imgUrl: imgUrl, // 分享图标
          success: function () {
            console.log("share1 success");
          },
        });

        wx.updateTimelineShareData({
          title: title, // 分享标题
          link: link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
          imgUrl: imgUrl, // 分享图标
          success: function () {
            console.log("share2 success");
          },
        });
      });
    },
    onClickDisabled() {
      this.$toast("开发中，敬请期待");
    },
    // 切换tab
    tabChange: function (num) {
      this.active = num * 1;
      // console.log(this.active * 1);
    },
    // 判断路由
    luYou() {
      var str = location.href;
      var b = str.split("?");
      // console.log(b);
      var c = " ";
      var url = "";
      console.log(str);
      if (str.indexOf("#/") != -1) {
        console.log("有");
        if (b[1]) {
          b = str.split("/");
          c = b[b.length - 1];
          url = c.slice(0, 5);
        } else {
          b = str.split("/");
          c = b[b.length - 1];
          url = c.slice(0, 5);
        }
      } else {
        console.log("无");
        b = str.split("/");
        console.log(b);
        c = b[b.length - 1];
        console.log(c);
        url = c.slice(0, 5);
        console.log(url);
      }
      switch (url) {
        case "Infor":
          this.active = 2;
          break;
        case "InfDe":
          this.active = 2;
          break;
        case "BroDe":
          this.active = 1;
          break;
        case "Broad":
          this.active = 1;
          break;
        case "Video":
          this.active = 3;
          break;
        case "Mito":
          this.active = 6;
          break;
        case "MitoD":
          this.active = 6;
          break;
        default:
          this.active = 0;
          this.$router.replace("/");
      }
    },
  },
  async created() {
    const res = await jssdkConfig({
      url: encodeURIComponent(location.href.split("#")[0]),
    });
    /* eslint-disable */
    wx.config({
      debug: false, // 开启调试模式,
      appId: res.appId, // 必填，企业号的唯一标识，此处填写企业号corpid
      timestamp: res.timestamp, // 必填，生成签名的时间戳
      nonceStr: res.nonceStr, // 必填，生成签名的随机串
      signature: res.signature, // 必填，签名，见附录1
      jsApiList: ["updateAppMessageShareData", "updateTimelineShareData"], // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
    });
    const title = "游呗旅行网";
    const imgUrl = "https://www.uobay.com/images/sharelogo.png";
    const desc = "游呗旅行网——旅游综合服务平台";
    // const desc = res.data.brief_introduction.substring(0, 30)
    let link = "";
    link = location.href;
    wx.ready(() => {
      wx.updateAppMessageShareData({
        title: title, // 分享标题
        desc: desc, // 分享描述
        link: link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
        imgUrl: imgUrl, // 分享图标
        success: function () {
          console.log("share1 success");
        },
      });

      wx.updateTimelineShareData({
        title: title, // 分享标题
        link: link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
        imgUrl: imgUrl, // 分享图标
        success: function () {
          console.log("share2 success");
        },
      });
    });
    this.luYou();

    postHome().then((res) => {
      this.detail = res.data;
    });
  },
  mounted: function () {
    if (isPc()) {
      //pc端
    } else {
      //移动端
      document.querySelector("#mid").style.width = "123%";
      document.querySelector("#bot").style.width = "123%";
      document.querySelector("#box").style.width = "1200px";
      document.querySelector("html").style.height = "123%";
    }
  },
};
</script>



<style lang="stylus">
html, body {
  height: 100%;
}

h1, h2, h3, h4, h5, p {
  margin: 0;
  padding: 0;
}

img {
  display: block;
}

.topBanner {
  width: 75rem;
  margin: 0 auto;
}

.teshu {
  width: 100%;
}

.dFlex {
  display: flex;
}

.midList {
  width: 37.5rem;
}

#app {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.box {
  flex: 1;
}

.share {
  position: relative;
}

.weiXin:hover+.qrcode {
  display: block;
}

.qrcode {
  position: absolute;
  left: 80px;
  top: 55px;
  display: none;
  z-index: 10000;
}

.share ul {
  display: flex;
  align-items: center;
  padding-top: 0.8rem;
  color: #9b9b9b;
}

.share li {
  margin-left: 1rem;
  cursor: pointer;
}

.shareIn {
  width: 6.25rem;
  text-align: center;
  background: #fff;
}

.time {
  margin: 0 2.125rem 0 1.5rem;
}

.top {
  width: 100%;
  padding: 0.5rem 0 0.3rem 0;
}

.topL {
  margin-right: 0.625rem;
  flex: 1;
}

.topL img {
  width: 14.5rem;
  height: 3.875rem;
}

// .topR img
// width 58.125rem
// height 3.875rem
.gzh {
  position: absolute;
  right: 1rem;
  top: 2.5rem;
  z-index: 1000;
  display: none;
}

.app {
  position: absolute;
  right: 13.625rem;
  top: 2.5rem;
  z-index: 1000;
  display: none;
}

.ybIcon {
  display: flex;
  width: 20rem;
  justify-content: space-between;
  margin-right: 1.3125rem;
  align-items: center;
  position: relative;
}

.ybIcon li img {
  width: 1.75rem;
  height: 1.75rem;
  z-index: 100;
}

.appIcon, .gzhIcon {
  display: flex;
  align-items: center;
  color: #fff;
  font-size: 0.9375rem;
  cursor: pointer;
}

.appIcon img, .gzhIcon img {
  margin-right: 0.625rem;
}

.gzhIcon:hover+.gzh {
  display: block;
}

.appIcon:hover+.app {
  display: block;
}

.mid {
  background: #434B58;
}

.mid .topBanner {
  display: flex;
  justify-content: space-between;
}

.wxDw .van-tabs--card>.van-tabs__wrap {
  height: 2.8125rem !important;
}

.wxDw .van-tabs__nav--card {
  border: none !important;
  height: 2.8125rem !important;
  line-height: 2.8125rem !important;
  margin: 0;
}

.wxDw .van-tabs__nav--card .van-tab {
  line-height: 2.8125rem !important;
  width: 6.125rem !important;
  border-right: 0.125rem solid #2D384A !important;
  font-size: 1.05rem;
}

.wxDw .van-tabs__content {
  width: 75rem;
}

.bot {
  box-sizing: border-box;
  padding: 1.75rem 0 1rem 0;
  height: 9.625rem;
  background: rgba(51, 51, 51, 1);
  color: rgba(237, 237, 237, 1);
}

.botBanT {
  display: flex;
  justify-content: space-around;
  align-items: center;
  margin-bottom: 2.6875rem;
}

h5 {
  font-size: 1.125rem;
  font-weight: 500;
  color: rgba(255, 255, 255, 1);
  line-height: 2.375rem;
}

.botText {
  font-size: 0.875rem;
  font-weight: 400;
  color: rgba(237, 237, 237, 1);
  line-height: 2.375rem;
}

.teShu {
  height: 7.625rem;
}

.teshu2 {
  height: 7.625rem;
  width: 0.0625rem;
  background: #fff;
}

.botBanRout {
  font-size;
}

.botBanR {
  display: flex;
  margin-bottom: 1.375rem;
}

.botBanTt {
  font-size: 1rem;
  font-weight: 400;
  color: rgba(237, 237, 237, 1);
  line-height: 1.4375rem;
}

.botBanBb {
  font-size: 0.875rem;
  font-weight: 400;
  color: rgba(237, 237, 237, 1);
  line-height: 1.4375rem;
}

.botIcont {
  padding-top: 0.25rem;
  margin-right: 0.8125rem;
}

.botBanB {
  flex-direction: column;
  align-items: center;
  font-size: 0.875rem;
  font-weight: 400;
  color: rgba(237, 237, 237, 1);
  line-height: 1.75rem;
}

video::-webkit-media-controls-fullscreen-button {
  display: none;
}

.ewmText {
  width: 6rem;
  text-align: center;
  background: #fff;
  border-radius: 0.6rem 0.6rem 0 0;
  font-size: 0.9375rem;
}

.topTwo {
  margin-bottom: 1.25rem;
  display: none;
}

.topInL img {
  width: 500px;
}

.topInR img {
  width: 700px;
  height: 130px;
}

.mBx {
  height: 6.375rem;
  background: #ff5e04;
  padding-left: 1.875rem;
  display: flex;
  align-items: center;
  font-size: 3rem;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: rgba(255, 255, 255, 1);
  display: none;
}

.mBx a {
  color: #fff;
}
</style>
